import { render, staticRenderFns } from "./icon-truck-packing.vue?vue&type=template&id=33a9299e&"
import script from "./icon-truck-packing.vue?vue&type=script&lang=js&"
export * from "./icon-truck-packing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports